import { useState } from "react"
import { bool, func, shape } from "prop-types"
import { DropdownMenu } from "components/ui"
import { Select } from "components/ui"
import sortBy from "utils/sorter"

const FilterDropdown = ({
  filterOptions,
  filterMenuItems,
  searches,
  onSubmit,
  isRegisterForSeparateTimesEnabled
}) => {
  const [searchCategory, setSearchCategory] = useState("")

  const handleCategoryChange = e => setSearchCategory(e.target.value)

  const renderSelection = () => {
    const options = sortBy(
      "label",
      Object.entries(filterMenuItems)
        .filter(([_k, v]) => v.dropdown && v.dropdown.isShowing)
        .map(([key, value]) => ({
          value: key,
          ...value.dropdown
        }))
    )

    return (
      <div className="px-2 pt-2" style={{ width: 280 }}>
        <label htmlFor="searchCategory">Filter by</label>
        <Select
          name="searchCategory"
          id="searchCategory"
          value={searchCategory}
          onChange={handleCategoryChange}
          options={[{ value: "", label: "Select filter" }, ...options]}
        />
      </div>
    )
  }

  const renderOptions = () => {
    const FilterOptionComponent = searchCategory ? filterMenuItems[searchCategory].component : null

    return (
      <div className="p-2" style={{ width: 280 }}>
        {searchCategory && (
          <FilterOptionComponent
            onSubmit={onSubmit}
            selected={searches[searchCategory] || {}}
            options={filterOptions[searchCategory] || []}
            isRegisterForSeparateTimesEnabled={isRegisterForSeparateTimesEnabled}
          />
        )}
      </div>
    )
  }

  const dropdownItems = [
    { key: "selections", render: renderSelection },
    { key: "options", render: renderOptions }
  ]

  return (
    <DropdownMenu
      className="xs-btn btn2 action-btn"
      text="Add filter"
      dropdownIcon="general#down-caret"
      items={dropdownItems}
    />
  )
}

FilterDropdown.propTypes = {
  filterOptions: shape({}),
  filterMenuItems: shape({}),
  searches: shape({}),
  onSubmit: func,
  isRegisterForSeparateTimesEnabled: bool
}

export default FilterDropdown
